import { FSharpRef, Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { ImageData, ImageData_$reflection } from "../Common/CommonTypes.js";
import { AllMeshData, AdditionalMeasurementData, StudyMeshData, AdditionalMeasurementData_$reflection, AllMeshData_$reflection } from "./MeshesBindings.js";
import { record_type, option_type, string_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { ofArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { skip, item, equalsWith, map } from "../../fable_modules/fable-library-js.4.19.3/Array.js";
import { printf, toText, substring, endsWith, isNullOrEmpty, split } from "../../fable_modules/fable-library-js.4.19.3/String.js";
import { comparePrimitives, defaultOf } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import * as jszip from "jszip";
import { promise } from "../../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { addToDict } from "../../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { exists, choose, tryFind, map as map_1, isEmpty, empty, length, filter, sortBy, cache } from "../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { match } from "../../fable_modules/fable-library-js.4.19.3/RegExp.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { tryParse } from "../../fable_modules/fable-library-js.4.19.3/Int32.js";
import { Option_ofBoolAndValue } from "../../Common/Extensions.js";
import { map as map_3, ofArray as ofArray_1 } from "../../fable_modules/fable-library-js.4.19.3/Map.js";

export class ExtractedData extends Record {
    constructor(ImageData, MeshData, AdditionalMeasurements, Checksum) {
        super();
        this.ImageData = ImageData;
        this.MeshData = MeshData;
        this.AdditionalMeasurements = AdditionalMeasurements;
        this.Checksum = Checksum;
    }
}

export function ExtractedData_$reflection() {
    return record_type("RAWMap.Client.Visualization.Meshes.Extraction.ExtractedData", [], ExtractedData, () => [["ImageData", ImageData_$reflection()], ["MeshData", AllMeshData_$reflection()], ["AdditionalMeasurements", AdditionalMeasurementData_$reflection()], ["Checksum", option_type(string_type)]]);
}

export function parseDataFileCsvStringToList(csvString) {
    let array_1;
    return ofArray(map((line_1) => {
        const matchValue = split(line_1, [","], undefined, 0);
        if (!equalsWith((x, y) => (x === y), matchValue, defaultOf()) && (matchValue.length === 2)) {
            const value_2 = item(1, matchValue);
            return [item(0, matchValue), value_2];
        }
        else {
            throw new Error("Invalid CSV format: each row must have exactly two values (key,value)");
        }
    }, skip(1, (array_1 = map((line) => line.trim(), split(csvString, ["\n"], undefined, 0)), array_1.filter((arg) => !isNullOrEmpty(arg))))));
}

export function extractData(zipBuffer) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const zip = new jszip();
        return zip.loadAsync(zipBuffer.arrayBuffer).then((_arg) => {
            const zipFile = _arg;
            const fileData = new Map([]);
            zipFile.forEach((_relPath, file) => {
                const zipObj = zipFile.files[file.name];
                const outputByTypePromise = zipObj.async("arraybuffer");
                addToDict(fileData, file.name, outputByTypePromise);
            });
            const getFilesForPath = (pathFragment, required) => {
                const filesForExt = (ext) => cache(sortBy((kvp_2) => kvp_2[0], filter((kvp_1) => {
                    if (kvp_1[0].indexOf(`UI_Files${pathFragment}`) === 0) {
                        return endsWith(kvp_1[0], ext);
                    }
                    else {
                        return false;
                    }
                }, fileData), {
                    Compare: comparePrimitives,
                }));
                let files;
                const nrrd = filesForExt(".nrrd");
                if (length(nrrd) > 0) {
                    files = nrrd;
                }
                else {
                    const dcm = filesForExt(".dcm");
                    files = ((length(dcm) > 0) ? dcm : empty());
                }
                if (required && isEmpty(files)) {
                    return Promise.reject(new Error("Missing standard Imaging data"));
                }
                else if (isEmpty(files)) {
                    return Promise.resolve(new Array(0));
                }
                else {
                    const pr = map_1((kvp) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (kvp[1].then((_arg_1) => {
                        let fileName;
                        return Promise.resolve(new File([_arg_1], ((fileName = kvp[0], substring(fileName, fileName.lastIndexOf("/") + 1)))));
                    })))), files);
                    return Promise.all(pr);
                }
            };
            return getFilesForPath("/phase00", true).then((_arg_2) => (getFilesForPath("/centerline", false).then((_arg_3) => (getFilesForPath("/masks/lumen", false).then((_arg_4) => (getFilesForPath("/masks/wall", false).then((_arg_5) => (getFilesForPath("/masks/visceral", false).then((_arg_6) => (getFilesForPath("/masks/centerline-lumen", false).then((_arg_7) => (getFilesForPath("/masks/centerline-wall", false).then((_arg_8) => {
                const csvStringPromise = (filename) => {
                    let fullFileName;
                    const path2 = filename;
                    fullFileName = toText(printf("%s/%s"))("UI_Files")(path2);
                    const file_1 = zipFile.files[fullFileName];
                    const _arg_9 = (file_1 == null) ? undefined : file_1.async("text");
                    if (_arg_9 == null) {
                        return Promise.resolve(undefined);
                    }
                    else {
                        const pr_1 = _arg_9;
                        return pr_1.then((Value_1) => Value_1);
                    }
                };
                const getMeshData = (dir) => {
                    const asArrayBuffer = (data) => data;
                    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                        const getMeshPromise = (fileName_1) => {
                            let fullFileName_1;
                            const path1_1 = dir;
                            const path2_1 = fileName_1;
                            fullFileName_1 = ((path1_1 === "") ? path2_1 : toText(printf("%s/%s"))(path1_1)(path2_1));
                            const _arg_10 = tryFind((kvp_3) => (kvp_3[0].indexOf(fullFileName_1) >= 0), fileData);
                            if (_arg_10 != null) {
                                return _arg_10[1];
                            }
                            else {
                                return Promise.reject(new Error(toText(printf("Missing %s"))(fullFileName_1)));
                            }
                        };
                        return getMeshPromise("Anatomy.vtp").then((_arg_11) => {
                            let pr_3, pr_2;
                            return ((pr_3 = ((pr_2 = getMeshPromise("Diameter_Growth.vtp"), pr_2.then((Value_2) => Value_2))), pr_3.catch((_arg_12) => undefined))).then((_arg_13) => (getMeshPromise("Lumen.vtp").then((_arg_14) => (getMeshPromise("Lumen_Centerline.vtp").then((_arg_15) => (getMeshPromise("RAW.vtp").then((_arg_16) => (getMeshPromise("Wall.vtp").then((_arg_17) => (getMeshPromise("Wall_Centerline.vtp").then((_arg_18) => (getMeshPromise("Renal_Artery.vtp").then((_arg_19) => {
                                let ringsFolder, path1_2, pr_6, pr_5;
                                return ((ringsFolder = ((path1_2 = dir, (path1_2 === "") ? "rings" : toText(printf("%s/%s"))(path1_2)("rings"))), (pr_6 = ((pr_5 = choose((kv) => {
                                    let tupledArg, outArg;
                                    const regexGroups = match(/UI_Files\/rings\/(\d+).vtp/gu, kv[0]);
                                    return map_2((k) => (kv[1].then((v_1) => [k, v_1])), (!(regexGroups == null) && (regexGroups.length > 1)) ? ((tupledArg = ((outArg = 0, [tryParse(regexGroups[1] || "", 511, false, 32, new FSharpRef(() => outArg, (v) => {
                                        outArg = (v | 0);
                                    })), outArg])), Option_ofBoolAndValue(tupledArg[0], tupledArg[1]))) : undefined);
                                }, filter((kvp_5) => (kvp_5[0].indexOf(ringsFolder) >= 0), fileData)), Promise.all(pr_5))), pr_6.then((elements) => ofArray_1(elements, {
                                    Compare: comparePrimitives,
                                }))))).then((_arg_20) => {
                                    const meshData = new StudyMeshData(asArrayBuffer(_arg_11), map_2(asArrayBuffer, _arg_13), asArrayBuffer(_arg_14), asArrayBuffer(_arg_15), asArrayBuffer(_arg_16), asArrayBuffer(_arg_17), asArrayBuffer(_arg_18), asArrayBuffer(_arg_19), map_3((k_1, v_2) => asArrayBuffer(v_2), _arg_20));
                                    return Promise.resolve(meshData);
                                });
                            })))))))))))));
                        });
                    }));
                };
                const asString = (data_1) => {
                    const matchValue = data_1;
                    if (typeof matchValue === "string") {
                        const s = matchValue;
                        return s;
                    }
                    else {
                        return undefined;
                    }
                };
                return csvStringPromise("geometryData.csv").then((_arg_21) => (csvStringPromise("growthData.csv").then((_arg_22) => {
                    const additionalMeasurements = new AdditionalMeasurementData(map_2(parseDataFileCsvStringToList, asString(_arg_21)), map_2(parseDataFileCsvStringToList, asString(_arg_22)));
                    return getMeshData("UI_Files").then((_arg_23) => {
                        let pr_7;
                        return (exists((kvp_6) => (kvp_6[0].indexOf("Previous_Study_Files") === 0), fileData) ? ((pr_7 = getMeshData("Previous_Study_Files"), pr_7.then((Value_3) => Value_3))) : (Promise.resolve(undefined))).then((_arg_24) => {
                            const meshData_1 = new AllMeshData(_arg_23, _arg_24);
                            return Promise.resolve(new ExtractedData(new ImageData(_arg_2, _arg_3, _arg_4, _arg_5, _arg_6, _arg_7, _arg_8), meshData_1, additionalMeasurements, zipBuffer.checksum));
                        });
                    });
                })));
            })))))))))))));
        });
    }));
}

